const portfolioData = [
  {
    id: '01',
    live_demo: 'https://github.com/SaidRasinlic/Law-Firm#law-firm',
    title: 'Law-Firm',
    description: 'This is my first freelance project, which I completed for my client, a lawyer, and I\'m happy to report that he was really pleased with the results. I wanted to make it appear both contemporary and timeless because law should always have a classic feel to it. You won\'t be able to perform CRUD operations on this project because it is connected to an API hosted on CPanel which only client has access to; instead, you will only be able to view the blogs that the author (in this case, my client), once he makes them, has written. Please feel free to browse the pages or send emails (a dummy email is used in this development mode) to see the design that I created. CMS was built by myself with NodeJS and React. This project is READ only.',
    src: 'https://raw.githubusercontent.com/SaidRasinlic/Law-Firm/gh-pages/Law-Snap.png',
    date: '27 Februrary 2023',
    technologies: ['React (front-end)', 'Node (back-end)', 'MySQL', 'SCSS & CSS'],
    authors: ['Said Rašinlić'],
    position: 'center',
  },
  {
    id: '02',
    live_demo: 'https://github.com/SaidRasinlic/student_registration_system',
    title: 'Student-Registration-System',
    description: 'A simple, incomplete Turbo-Dashboard template for future reference.',
    src: 'https://raw.githubusercontent.com/SaidRasinlic/student_registration_system/dev/app/assets/images/Turbo-Dashboard.png',
    date: '23 May 2024',
    technologies: ['Ruby on Rails', 'PostgreSQL', 'SCSS, CSS'],
    authors: ['Said Rašinlić'],
    position: 'center',
  },
  {
    id: '03',
    live_demo: 'https://github.com/SaidRasinlic/Quote-Editor-Hotrails#quote-editor-hotrails',
    title: 'Quote-Editor-Hotrails',
    description: 'With the quote editor, you can create, update and delete quotes. When clicking on a quote, you access the page to create, update and delete dates. On each date, you can add line items. Every time you create, update, or delete a line item, the quote total gets updated.',
    src: 'https://raw.githubusercontent.com/SaidRasinlic/Quote-Editor-Hotrails/dev/app/assets/images/Project-Snapshot.png',
    date: '12 May 2023',
    technologies: ['RoR', 'Hotwire', 'SCSS', 'Tailwind CSS', 'PostgreSQL'],
    authors: ['Said Rašinlić'],
    position: '29% center',
  },
  {
    id: '04',
    live_demo: 'https://github.com/SaidRasinlic/To-Do-RoR-Hotwire#to-do-ror-hotwire',
    title: 'To-Do-RoR-Hotwire',
    description: 'This is a RoR + Hotwire To-Do List project with basic CRUD operations. The main goal of this application is to understand how Hotwire front-end frameworks (a suite of different frameworks) works. This application also represents traditional web architecture (server-rendered HTML), without the complexity of modern JavaScript frameworks like React.',
    src: 'https://raw.githubusercontent.com/SaidRasinlic/To-Do-RoR-Hotwire/dev/app/assets/images/Project-Snapshot.png',
    date: '27 Februrary 2023',
    technologies: ['RoR', 'Hotwire', 'Tailwind CSS', 'PostgreSQL'],
    authors: ['Said Rašinlić'],
    position: '15% center',
  },
  {
    id: '05',
    live_demo: 'https://github.com/SaidRasinlic/Budget-App#budget-app',
    title: 'Budget-App (mobile)',
    description: 'This Ruby on Rails capstone project is about building a mobile web application where you can manage your budget: you have a list of transactions associated with a category, so that you can see how much money you spent and on what.',
    src: 'https://raw.githubusercontent.com/SaidRasinlic/Budget-App/dev/app/assets/images/Budget-Snap.png',
    date: '28 October 2022',
    technologies: ['RoR', 'PostgreSQL', 'Bootstrap', 'CSS & SCSS'],
    authors: ['Said Rašinlić'],
    position: 'center',
  },
  {
    id: '06',
    live_demo: 'https://github.com/SaidRasinlic/Free-To-Play-Games#free-to-play-games',
    title: 'Free-To-Play Games',
    description: 'This is the JavaScript capstone project, which is based on an external API. The data of the games, which is fetched from the API, it gets displayed on the cards. The user can leave a comment on the game cards and give it a like also.',
    src: 'https://raw.githubusercontent.com/SaidRasinlic/Free-To-Play-Games/development/src/assets/images/Free-To-Play-Games-Desktop.png',
    date: '29 November 2022',
    technologies: ['JavaScript', 'HTML', 'CSS/SCSS', 'Jest'],
    authors: ['Said Rašinlić', 'Virag Kormoczy'],
    position: 'center',
  },
  {
    id: '07',
    live_demo: 'https://github.com/SaidRasinlic/Leaderboard#leaderboard',
    title: 'Leaderboard-App',
    description: 'Description for project 77 JAHDADHJADJ ADad akda kdkasfk asfsdjfsdkg kdgjdskg sgj kfgj dfkhkd fjkdfkh dfjkh jkdfhkjdfjk hfkjfkl',
    src: 'https://raw.githubusercontent.com/SaidRasinlic/Leaderboard/dev/src/assets/images/Leaderboard.png',
    date: '19 May 2022',
    technologies: ['JavaScript (ES6)', 'HTML', 'CSS'],
    authors: ['Said Rašinlić'],
    position: 'center',
  },
  {
    id: '08',
    live_demo: 'https://github.com/SaidRasinlic/Math-Magicians#math-magicians',
    title: 'Math-Magician',
    description: 'Math magicians" is a website for all fans of mathematics. It is a Single Page App (SPA) that allows users to: Make simple calculations. Read a random math-related quote.',
    src: 'https://raw.githubusercontent.com/SaidRasinlic/Math-Magicians/development/src/assets/images/Math-Magicians.png',
    date: '5 May 2022',
    technologies: ['JavaScript (ES6)', 'HTML', 'CSS'],
    authors: ['Said Rašinlić'],
    position: 'left',
  },
  {
    id: '09',
    live_demo: 'https://github.com/SaidRasinlic/Tracker-Covid-19#tracker-covid-19',
    title: 'Tracker-Covid-19',
    description: 'This React capstone project is about building a Mobile Web Application to check a list of metrics (numeric values) that I will create making use of React and Redux. Thanks to the COVID-19 metrics I was able to fetch data by using Fetch API, which helped me to get the all the stats per country needed for the project.',
    src: 'https://raw.githubusercontent.com/SaidRasinlic/Tracker-COVID-19/development/src/assets/images/covid.png',
    date: '28 May 2022',
    technologies: ['JavaScript (ES6)', 'React', 'Redux', 'CSS & SCSS'],
    authors: ['Said Rašinlić'],
    position: '25%',
  },
  {
    id: '10',
    live_demo: 'https://github.com/SaidRasinlic/Mern-Stack-Frontend#mern-stack-frontend',
    title: 'MERN-Stack-Frontend',
    description: 'This MERN Stack Full Tutorial & Project provides a complete all-in-one course with 13 clearly defined "chapters" of code and instruction to level up my web development skills. RTK queries and advanced way of using React!',
    src: 'https://raw.githubusercontent.com/SaidRasinlic/MERN-Stack-Frontend/main/src/assets/images/TechNotes.png',
    date: '20 August 2023',
    technologies: ['React', 'Redux', 'RTK Queries'],
    authors: ['Said Rašinlić'],
    position: 'left',
  },
  {
    id: '11',
    live_demo: 'https://github.com/SaidRasinlic/Bookstore-React#bookstore-react',
    title: 'Bookstore-React',
    description: 'This project will lay foundations for my Bookstore website. I will create the React part of the app (components,hooks, events, and more). I will also set up routing using React Router and do as much as I can to provide professional look & feel to the project.',
    src: 'https://raw.githubusercontent.com/SaidRasinlic/Bookstore-React/development/src/assets/images/Bookstore-React.png',
    date: '20 May 2022',
    technologies: ['JavaScript (ES6)', 'React', 'Redux', 'CSS & SCSS'],
    authors: ['Said Rašinlić'],
    position: 'left',
  },
  {
    id: '12',
    live_demo: 'https://github.com/SaidRasinlic/WorldCupQatar#world-cup-qatar-2022-project',
    title: 'World-Cup-Qatar',
    description: 'This is my personal "World Cup Qatar 2022 International Conference" website which I created for the Microverse assignment, in this project we had to choose our own website idea and create home and about page. Since I\'ve always been the football fan I chose to create something like fake World Cup 2022 conference, and from this moment I\'m writing this all the football fans are waiting for that big moment which is in a few months from now.',
    src: 'https://raw.githubusercontent.com/SaidRasinlic/WorldCupQatar/development/resources/img/WorldCupDesktop.png',
    date: '13 February 2022',
    technologies: ['JavaScript (ES6)', 'HTML', 'CSS & SCSS', 'Bootstrap', 'jQuery'],
    authors: ['Said Rašinlić'],
    position: 'left',
  },
  {
    id: '13',
    live_demo: 'https://github.com/SaidRasinlic/Recipe-App#recipe-app',
    title: 'Recipe-App',
    description: 'The Recipe app keeps track of all your recipes, ingredients, and inventory. It will allow you to save ingredients, keep track of what you have, create recipes, and generate a shopping list based on what you have and what you are missing from a recipe. Also, since sharing recipes is an important part of cooking the app should allow you to make them public so anyone can access them.',
    src: 'https://raw.githubusercontent.com/SaidRasinlic/Recipe-App/dev/app/assets/images/Recipe-App-Snapshot.png',
    date: '15 October 2022',
    technologies: ['RoR', 'React', 'PostgreSQL', 'CSS'],
    authors: ['Said Rašinlić', 'Dozie Udeagha', 'Bright Kweku Ahiadeke'],
    position: 'left',
  },
  {
    id: '14',
    live_demo: 'https://github.com/SaidRasinlic/Realtime-Search-Box#realtime-search-box',
    title: 'Realtime-Search-Box',
    description: 'This Real-Time Search app delivers instant search results as you type, powered by Ruby on Rails, PostgreSQL, and Chartkick. It also tracks popular queries in real-time, providing valuable insights into user trends.',
    src: 'https://raw.githubusercontent.com/SaidRasinlic/RealTime-Search-Box/dev/app/assets/images/Realtime-Search-Box.png',
    date: '22 August 2023',
    technologies: ['RoR', 'PostgreSQL', 'Chartkick', 'JavaScript (Importmaps Rails 7)', 'SCSS'],
    authors: ['Said Rašinlić'],
    position: 'left',
  },
  {
    id: '15',
    live_demo: 'https://github.com/SaidRasinlic/Blog-App-II#blog-app',
    title: 'Blog-App',
    description: 'The Blog app will be a classic example of a blog website. I will create a fully functional website that will show the list of posts and empower readers to interact with them by adding comments and liking posts.',
    src: 'https://raw.githubusercontent.com/SaidRasinlic/Blog-App-II/dev/app/assets/images/Blog-App-II.png',
    date: '25 October 2022',
    technologies: ['RoR', 'PostgreSQL', 'Bootstrap', 'CSS & SCSS'],
    authors: ['Said Rašinlić'],
    position: '15%',
  },
  {
    id: '16',
    live_demo: 'https://github.com/SaidRasinlic/Redux-Toolkit#redux-toolkit-blog-app-with-advanced-rtk-queries-from-the-redux-toolkit',
    title: 'Redux-Toolkit',
    description: 'This is a Blog-App built with React and Redux but with way harder optimizations and advanced skills like optimistic updates, normalization, RTK queries, memoization and more! RTK Query is an advanced data fetching and caching tool, designed to simplify common cases for loading data in a web application. RTK Query itself is built on top of the Redux Toolkit core, and leverages RTK\'s APIs like createSlice and createAsyncThunk to implement its capabilities.',
    src: 'https://raw.githubusercontent.com/SaidRasinlic/Redux-Toolkit/main/public/Project-Snapshot.png',
    date: '14 June 2023',
    technologies: ['React', 'Redux', 'CSS'],
    authors: ['Said Rašinlić'],
    position: 'center',
  },
  {
    id: '17',
    live_demo: 'https://github.com/SaidRasinlic/Awesome-Books-ES6#awesome-books-with-es6-plain-javascript-with-objects',
    title: 'Awesome Books (ES6)',
    description: 'The Awesome-Books project has been updated to use the new ES6 syntax. This is a simple SPA (Single Page Application) that uses JavaScript classes to construct and manage DOM components and JavaScript events. USER INTERFACE with the ability to ADD and REMOVE books.',
    src: 'https://raw.githubusercontent.com/SaidRasinlic/Awesome-Books-ES6/main/img/Desktop-Awesome-Books.png',
    date: '7 December 2022',
    technologies: ['JavaScript', 'HTML', 'CSS'],
    authors: ['Said Rašinlić'],
    position: 'center',
  },
  {
    id: '18',
    live_demo: 'https://github.com/SaidRasinlic/To-Do-List#to-do-list',
    title: 'To-Do List',
    description: 'This is a very simple application built with a Webpack and served by the Webpack dev server. User can easily add, remove, drag & drop, and mark as checked his day tasks.',
    src: 'https://raw.githubusercontent.com/SaidRasinlic/To-Do-List/development/src/img/To-Do-List-Desktop.png',
    date: '19 May 2022',
    technologies: ['JavaScript', 'HTML', 'CSS'],
    authors: ['Said Rašinlić'],
    position: '40%',
  },
];

export default portfolioData;
